import AirbnbService from 'src/services/airbnbService.js';

const state = {
  airbnbAccounts: undefined,
};

const getters = {
  getAirbnbAccounts: (state) => state.airbnbAccounts,
};
const actions = {
  async fetchAirbnbAccounts({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.airbnbAccounts == undefined) {
      return AirbnbService.fetchAccounts()
      .then(r => {
        commit('setAccounts', r.data);
      });
    }
  },
  unloadAirbnbAccounts({ commit }) {
    commit('setAccounts', undefined);
  }
};
const mutations = {
  setAccounts(state, accts) {
    state.airbnbAccounts = accts;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
